var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD8\xB3\xD9\x87\xD9\x85 \xD9\x84\xD9\x84\xD9\x8A\xD9\x85\xD9\x8A\xD9\x86 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16671 10.8334H14.05L11.025 14.4668C10.955 14.551 10.9022 14.6482 10.8698 14.7529C10.8373 14.8576 10.8258 14.9676 10.8359 15.0767C10.8562 15.297 10.9632 15.5003 11.1334 15.6418C11.3036 15.7832 11.523 15.8513 11.7433 15.8309C11.9637 15.8106 12.1669 15.7036 12.3084 15.5334L16.475 10.5334C16.5031 10.4936 16.5281 10.4519 16.55 10.4084C16.55 10.3667 16.5917 10.3417 16.6084 10.3001C16.6461 10.2045 16.6659 10.1028 16.6667 10.0001C16.6659 9.89734 16.6461 9.79563 16.6084 9.70008C16.6084 9.65842 16.5667 9.63342 16.55 9.59175C16.5281 9.5483 16.5031 9.50652 16.475 9.46675L12.3084 4.46675C12.23 4.37268 12.1319 4.29703 12.021 4.24518C11.9101 4.19333 11.7891 4.16655 11.6667 4.16675C11.472 4.16637 11.2833 4.23418 11.1334 4.35842C11.049 4.42837 10.9792 4.51429 10.9281 4.61125C10.877 4.7082 10.8455 4.81429 10.8354 4.92344C10.8254 5.03259 10.8369 5.14265 10.8695 5.24732C10.902 5.35199 10.9549 5.44921 11.025 5.53342L14.05 9.16675H4.16671C3.94569 9.16675 3.73373 9.25455 3.57745 9.41083C3.42117 9.56711 3.33337 9.77907 3.33337 10.0001C3.33337 10.2211 3.42117 10.4331 3.57745 10.5893C3.73373 10.7456 3.94569 10.8334 4.16671 10.8334Z",
    fill: "#EFF9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSb);
export default __webpack_public_path__ + "static/media/logoutSb.a443a7be3f93f084be6e8af819c5d931.svg";
export { ForwardRef as ReactComponent };